// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import dimensionsIcon from "@iconify/icons-tabler/dimensions";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Portal } from "@mui/base";
// import * as Yup from "yup";
// material
import {
  Card,
  Table,
  Stack,
  Tooltip,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Breadcrumbs,
  Link,
  ListSubheader,
  IconButton,
  CircularProgress,
  Autocomplete,
  createFilterOptions,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import outlineImage from "@iconify/icons-ic/outline-image";
import { CallApi, BaseURL } from "../statics.js";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const defaultFilterOptions = createFilterOptions();

const TABLE_HEAD = [
  { id: "title", label: "Title", alignRight: false },
  { id: "code", label: "Code", alignRight: false },
  { id: "pic", label: "Picture", alignRight: false },
  { id: "dimension", label: "Dimension & Price", alignRight: false },
  { id: "priority", label: "Priority", alignRight: false },
  { id: "" },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function DetailItems() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [currentLocItem, setCurrentLocItem] = useState({ title: "" });
  const [actionMode, setActionMode] = useState("accepting");
  const [dialogMode, setDialogMode] = useState("add");
  const [detailTitle, setDetailTitle] = useState("");
  const [detailTitleErrorText, setDetailTitleErrorText] = useState("");
  const [detailDes, setDetailDes] = useState("");
  const [detailDesErrorText, setDetailDesErrorText] = useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  const [obsoletedValue, setObsoletedValue] = useState("");
  const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  // const [addDetailLoading, setAddDetailLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("priority");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [priceTypeList, setPriceTypeList] = useState([]);

  const [dimensionTypeList, setDimensionTypeList] = useState([]);
  const [dimensionTypeValue, setDimensionTypeValue] = useState("");
  const [dimensionTypeValueErrorText, setDimensionTypeValueErrorText] =
    useState("");
  const [config, setConfig] = useState(null);
  const [currentDetailItem, setCurrentDetailItem] = useState({
    id: "",
    title: "",
  });
  const [priceValue, setPriceValue] = useState("");
  const [priceValueErrorText, setPriceValueErrorText] = useState("");
  const [parnetNameList, setParnetNameList] = useState([]);

  const [detailItemsList, setDetailItemsList] = useState([]);
  const [selectedDetailItemsValue, setSelectedDetailItemsValue] = useState([]);
  const [
    selectedDetailItemsValueErrorText,
    setSelectedDetailItemsValueErrorText,
  ] = useState("");
  const [codeValue, setCodeValue] = useState("");
  const [codeValueErrorText, setCodeValueErrorText] = useState("");
  const [picDialogOpen, setPicDialogOpen] = useState(false);
  const [currentItemsPic, setCurrentItemsPic] = useState(null);
  const [uploadList, setUploadList] = useState([]);
  const [detailItemsText, setDetailItemsText] = useState("");
  const [priorityValue, setPriorityValue] = useState("");

  const navigate = useNavigate();

  const editReplaceWith = useRef([]);

  let params = useParams();

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    findDetailItems();
  }, []);

  useEffect(() => {
    if (tableData.length > 0) setDataLoading(false);
  }, [tableData]);

  const findAllDetailItems = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      searchKey: "",
    };
    console.log(data);
    setButtonDisabled(true);
    CallApi("findAllDetailItems", "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            let temp = [];
            result.result.forEach((element) => {
              let p = element.title;
              element.detailItems.forEach((element1) => {
                element1.parentTitle = p;
                temp.push(element1);
              });
            });
            setDetailItemsList(temp);
          }
          setButtonDisabled(false);
        } catch (err) {
          setSnackType("error");
          setSnackbarMessage(err);
          setSnackbarOpen(true);
          setButtonDisabled(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
        setButtonDisabled(false);
      });
  };

  useEffect(() => {
    if (editReplaceWith.current.length > 0) {
      let sdi = [];
      detailItemsList.forEach((element) => {
        editReplaceWith.current.forEach((element1) => {
          if (element._id === element1) sdi.push(element);
        });
      });
      setSelectedDetailItemsValue(sdi);
      editReplaceWith.current = [];
    }
  }, [detailItemsList]);

  const findDetailItems = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      detailId: params.detailId,
      page: page,
      count: rowsPerPage,
    };
    console.log(data);
    setDataLoading(true);
    CallApi("findDetailItems", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setTableData(result.result);
          setParnetNameList(result.parnetNameList);
          setTotalItems(result.paginateInfo.totalItems);
        }

        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) findDetailItems();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const handleFilterByName = (event) => {
  //   setFilterName(event.target.value);
  // };

  // useEffect(() => {
  //   if (addDialogOpen) detailTitleTextField.current.focus();
  // }, [addDialogOpen]);

  const handleClickOpen = () => {
    setDialogMode("add");
    setDetailTitle("");
    setCodeValue("");
    setSelectedDetailItemsValue([]);
    setDetailTitleErrorText("");
    setCodeValueErrorText("");
    setDetailItemsText("");
    setPriorityValue("");
    setUploadList([]);
    setSelectedDetailItemsValueErrorText("");
    findAllDetailItems();
    setAddDialogOpen(true);
  };

  const addDetailItem = () => {
    if (!detailTitle) {
      setDetailTitleErrorText("Detail title cannot be empty");
      return;
    } else {
      setDetailTitleErrorText("");
    }

    if (!codeValue) {
      setCodeValueErrorText("Code cannot be empty");
      return;
    } else {
      setCodeValueErrorText("");
    }

    let rw = [];
    console.log(selectedDetailItemsValue);
    selectedDetailItemsValue.forEach((element) => {
      rw.push(element._id);
    });

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      title: detailTitle ? detailTitle : "",
      code: codeValue,
      pic: uploadList.length > 0 ? uploadList[0].fileName : "",
      detailId: params.detailId,
      priority: priorityValue,
      replaceWith: rw,
    };
    let apiname = "addItemToDetail";

    if (dialogMode === "update") {
      data = {
        username: getCookie("username"),
        token: getCookie("token"),
        detailItemId: currentDetailItem._id,
        title: detailTitle ? detailTitle : "",
        code: codeValue,
        pic: uploadList.length > 0 ? uploadList[0].fileName : "",
        priority: priorityValue,
        replaceWith: rw,
      };
      apiname = "updateDetailItems";
    }

    console.log(data);
    setButtonDisabled(true);

    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            findDetailItems();
            setSnackType("success");

            if (apiname === "addItemToDetail")
              setSnackbarMessage(
                "'" + detailTitle + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + detailTitle + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log(item);
      setCurrentDetailItem(item);
      setDialogMode("update");
      setDetailTitle(item.title);
      setCodeValue(item.code);
      setPriorityValue(
        item.priority || item.priority === 0 ? item.priority : ""
      );
      editReplaceWith.current = item.replaceWith;
      findAllDetailItems();
      setUploadList(
        item.pic
          ? [
              {
                file: { name: item.pic.replace("public/", "") },
                fileName: item.pic,
                status: "ok",
              },
            ]
          : []
      );
      setDetailItemsText("");
      setCodeValueErrorText("");
      setDetailTitleErrorText("");
      setSelectedDetailItemsValueErrorText("");
      findAllDetailItems();
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentDetailItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const handleChangeDimensionType = (event) => {
    const {
      target: { value },
    } = event;
    setDimensionTypeValue(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeObsoleted = (event) => {
    const {
      target: { value },
    } = event;
    setObsoletedValue(typeof value === "string" ? value.split(",") : value);
  };

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      detailItemId: currentDetailItem._id,
    };

    // console.log(data);

    setButtonDisabled(true);
    CallApi("removeDetailItems", "post", data)
      .then((result) => {
        try {
          // console.log(result);
          if (result.status === 200) {
            findDetailItems();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const getBreadcrumbsLink = (id) => {
    let l = "";
    let end = false;
    parnetNameList.forEach((element) => {
      if (!end) l += "/" + element._id;
      if (id === element._id) end = true;
    });

    return l.toString();
  };

  const handleChangeDetailItems = (event) => {
    const {
      target: { value },
    } = event;
    console.log(value);
    if (value && value.length > 0 && value[0])
      setSelectedDetailItemsValue(
        typeof value === "string" ? value.split(",") : value
      );
  };

  const onSelectFileComplete = (event) => {
    let files = [];

    for (let i = 0; i < event.target.files.length; i++) {
      // console.log(event.target.files[i]);
      if (
        !event.target.files[i] ||
        (event.target.files[i].type !== "image/jpg" &&
          event.target.files[i].type !== "image/png" &&
          event.target.files[i].type !== "image/webp" &&
          event.target.files[i].type !== "image/jpeg")
      ) {
        setSnackType("error");
        setSnackbarMessage("some files not valid for uploading");
        setSnackbarOpen(true);
        return;
      } else {
        files.push({ file: event.target.files[i], status: "loading" });
      }
    }

    setUploadList(files);
    document.getElementById("selectPicDialog").value = "";
  };

  useEffect(() => {
    if (uploadList.length > 0) {
      let found = false;
      uploadList.forEach((element) => {
        if (!found && element.status === "loading") {
          found = true;
          uploadFile(element.file);
        }
      });
    }
  }, [uploadList]);

  const uploadFile = (file) => {
    const data = new FormData();
    data.append("picture", file);
    data.append("username", getCookie("username"));
    data.append("token", getCookie("token"));

    console.log(file);
    CallApi("uploadPicture", "post", data, true)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "ok", fileName: result.fileName };
              }
              return obj;
            });

            setUploadList(newState);
          } else {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "failed" };
              }
              return obj;
            });

            setUploadList(newState);
          }
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        const newState = uploadList.map((obj) => {
          if (obj.file === file) {
            return { ...obj, status: "failed" };
          }
          return obj;
        });

        setUploadList(newState);
      });
  };

  const onResultClick = (item) => {
    setCurrentItemsPic(item.pic);
    setPicDialogOpen(true);
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  // || (dialogMode!=='update' && d.detailItems.length===1 && d.detailItems[0]._id)
  const renderSelectGroup = (dt) => {
    const items = dt.detailItems.map((dti) => {
      if (
        dialogMode !== "update" ||
        (dialogMode === "update" && currentDetailItem._id !== dti._id)
      ) {
        return (
          <MenuItem key={dti._id} value={dti._id}>
            {dti.title}
          </MenuItem>
        );
      }
    });
    console.log(items);
    if (items.length > 0 && items[0]) {
      return [<ListSubheader>{dt.title}</ListSubheader>, items];
    } else {
      return [];
    }
  };

  return (
    <Page title="Detail Items | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          ></Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          >
            {/* <Typography variant="h4" gutterBottom>
              Detail Item of
            </Typography> */}
            <Breadcrumbs aria-label="breadcrumb" mb={2}>
              <Link
                key={-1}
                underline="hover"
                color="inherit"
                href={"/details"}
              >
                Details
              </Link>
              {parnetNameList.map((item, i) => {
                if (i === parnetNameList.length - 1) {
                  return (
                    <Typography key={i} color="text.primary">
                      {item.title}
                    </Typography>
                  );
                } else
                  return (
                    <Link
                      key={i}
                      underline="hover"
                      color="inherit"
                      href={"/details" + getBreadcrumbsLink(item._id)}
                    >
                      {item.title}
                    </Link>
                  );
              })}
            </Breadcrumbs>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Detail Item
            </Button>
          </Stack>

          <Card>
            {/* <LocationListToolbar
              filterName={filterName}
              searchPlaceHolder="Search title..."
              onFilterName={handleFilterByName}
            /> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        const { _id, title, code, detailId, pic } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              <Typography variant="subtitle2" noWrap>
                                {title}
                              </Typography>
                            </TableCell>
                            <TableCell>{code}</TableCell>
                            <TableCell align="left">
                              {pic && (
                                <IconButton
                                  aria-label="result"
                                  onClick={() => {
                                    onResultClick(row);
                                  }}
                                >
                                  <Icon icon={outlineImage} fontSize={22} />
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell align="left">
                              <Link href={"/details/" + detailId + "/" + _id}>
                                <Box
                                  component={Icon}
                                  icon={dimensionsIcon}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                            </TableCell>
                            <TableCell>
                              {row.priority || row.priority === 0
                                ? row.priority
                                : "-"}
                            </TableCell>
                            <TableCell align="right">
                              <LocationMoreMenu
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}
      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        // keepMounted
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Detail Item</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" + currentDetailItem.title + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDeleteItem}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={addDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setAddDialogOpen(false);
        }}
      >
        <DialogTitle>
          {dialogMode === "add" ? "Add New Detail Item" : "Edit Detail Item"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <TextField
            fullWidth
            sx={{ mb: 2, mt: 2 }}
            autoFocus
            type="text"
            label="Title"
            value={detailTitle}
            // inputRef={detailTitleTextField}
            onChange={(e) => setDetailTitle(e.target.value)}
            disabled={buttonDisabled}
            // disabled={addDetailLoading}
            helperText={detailTitleErrorText}
            error={detailTitleErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Code"
            value={codeValue}
            onChange={(e) => setCodeValue(e.target.value)}
            disabled={buttonDisabled}
            helperText={codeValueErrorText}
            error={codeValueErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Priority"
            value={priorityValue}
            onChange={(e) => setPriorityValue(e.target.value)}
            disabled={buttonDisabled}
            // helperText={priorityValueErrorText}
            // error={priorityValueErrorText ? true : false}
          />

          {/* <FormControl
            sx={{ mb: 2 }}
            fullWidth
            error={selectedDetailItemsValueErrorText ? true : false}
            disabled={buttonDisabled}
          >
            <InputLabel>Replace With</InputLabel>
            <Select
              value={selectedDetailItemsValue}
              onChange={handleChangeDetailItems}
              multiple
              input={<OutlinedInput label="Replace With" />}
              MenuProps={MenuProps}
            >
              {detailItemsList?.map((d) => {
                if (d.detailItems.length > 0) return renderSelectGroup(d);
              })}
            </Select>
            <FormHelperText>{selectedDetailItemsValueErrorText}</FormHelperText>
          </FormControl> */}

          <FormControl fullWidth disabled={buttonDisabled}>
            <Autocomplete
              multiple
              options={
                dialogMode !== "update"
                  ? detailItemsList
                  : detailItemsList.filter(
                      (item) => item._id !== currentDetailItem._id
                    )
              }
              groupBy={(option) => option.parentTitle}
              getOptionLabel={(option) => option.title}
              filterSelectedOptions
              filterOptions={(options, state) => {
                if (detailItemsText && detailItemsText.length > 0)
                  return defaultFilterOptions(options, state).slice(0, 5);
                else return [];
              }}
              onChange={(e, a) => {
                setDetailItemsText("");
                setSelectedDetailItemsValue(a);
              }}
              noOptionsText={
                detailItemsText ? "No options" : "Write a detail item title"
              }
              value={selectedDetailItemsValue}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Replace With"
                  placeholder="Replace With"
                  onChange={(e) => {
                    setDetailItemsText(e.target.value);
                  }}
                  error={selectedDetailItemsValueErrorText ? true : false}
                  value={detailItemsText}
                />
              )}
            />
            <FormHelperText>{selectedDetailItemsValueErrorText}</FormHelperText>
          </FormControl>

          <Button
            fullWidth
            sx={{ mt: 2, mb: 1 }}
            // onClick={() => setDialogOpen(false)}
            variant="outlined"
            disabled={buttonDisabled}
            startIcon={<CloudUploadIcon />}
            component="label"
          >
            Upload Picture
            <input
              hidden
              accept="image/png,.jpg,.webp"
              // multiple
              type="file"
              onChange={onSelectFileComplete}
              id="selectPicDialog"
            />
          </Button>

          <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {uploadList.map((item, i) => {
              return (
                <Chip
                  disabled={buttonDisabled}
                  key={i}
                  sx={{ mb: 0.5, mr: 0.5 }}
                  icon={
                    item.status === "ok" ? (
                      <CheckIcon />
                    ) : item.status === "failed" ? (
                      <Tooltip title="Retry">
                        <IconButton
                          aria-label="retry"
                          size="small"
                          onClick={() => {
                            const newState = uploadList.map((obj) => {
                              if (obj.file === item.file) {
                                return { ...obj, status: "loading" };
                              }
                              return obj;
                            });

                            setUploadList(newState);
                          }}
                        >
                          <RefreshIcon sx={{ fontSize: "18px" }} />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <CircularProgress color="secondary" size={20} />
                    )
                  }
                  label={item.file.name}
                  variant="outlined"
                  color={
                    item.status === "ok"
                      ? "primary"
                      : item.status === "ok"
                      ? "error"
                      : "secondary"
                  }
                  onDelete={
                    item.status === "ok"
                      ? () => {
                          setUploadList((chips) =>
                            chips.filter((chip) => chip.file !== item.file)
                          );
                        }
                      : undefined
                  }
                />
              );
            })}
          </Box>

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={addDetailItem}
            variant="contained"
            disabled={buttonDisabled}
          >
            {dialogMode === "add" ? "Add" : "Update"}
          </Button>
          <Button
            onClick={() => setAddDialogOpen(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={picDialogOpen}
        TransitionComponent={Transition}
        onClose={() => {
          setPicDialogOpen(false);
        }}
      >
        <DialogContent>
          <img alt="" src={BaseURL + currentItemsPic} />
        </DialogContent>
      </Dialog>

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
